import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SearchResultComponent } from '@softapps/core';
import { Lagerplatz } from '../../../types/lagerplatz';

@Component({
  selector: 'soft-field-ok-lagerplatz-search-result-view',
  imports: [],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class LagerplatzFieldOkSearchResultViewComponent
  implements SearchResultComponent<Lagerplatz>
{
  readonly result = input.required<Lagerplatz>();
}
